import React, {useState} from 'react'
import ChatWindow from './ChatWindow';
import { Link } from 'react-router-dom';

const Home = () => {
//   const [inChat, setInChat] = useState(false);
//   const startChat = () =>{
//         setInChat(true);
//   };
  return (
    <div>
      <h1> GPT with React.js</h1>
      <Link  to='/chat'>
      <button> Start Chatting</button>
      </Link>
      {/* <div>
      {inChat? <ChatWindow/> : <Home />}
      </div> */}
    </div>
  )
}

export default Home
